module.exports = __webpack_public_path__ + "static/media/2_SE_IPPF_logo_old_edited_color.8c2a6c9e.png";